<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import Vue from 'vue'
  import router from './router'
  import VueAnalytics from 'vue-analytics'
  // Initiate Google analytics
  Vue.use(VueAnalytics, {
    id: 'UA-118069539-1',
    router
  })

export default {

}
</script>

<style lang="scss" scope>
  body { font-family: 'Maven Pro', sans-serif; }
  h1.serif, h2.serif, h3.serif { font-family: 'ZCOOL XiaoWei', serif; }
</style>



// WEBPACK FOOTER //
// App.vue?0be06cb7